import React from 'react';
import { WrappedFieldProps } from 'redux-form';

interface Label {
  label: string;
  type?: string;
  readOnly?: boolean;
}

type Props = Label & WrappedFieldProps;
export const Input = (props: Props) => {
  const renderError = () => {
    const { error, touched } = props.meta;
    if (error && touched) {
      return (
        <div className='ui error message'>
          <div className='header'>{error}</div>
        </div>
      );
    }
  };

  const { label, input, readOnly = false } = props;
  return (
    <div className='field'>
      <label>{label}</label>
      <input
        {...input}
        type={props.type || 'text'}
        autoComplete='off'
        readOnly={readOnly}
      />
      {renderError()}
    </div>
  );
};
